import { useEffect, useRef, useState } from 'react';
import { __ } from '@wordpress/i18n';
import axios from 'axios';
import './import_global_data.scss';

const { Fragment } = wp.element;

export const Import_gutenberg_global = (props) => {
    var temp_global = props.template_global;

    Object.entries(temp_global).map(([key, value]) => {
        let gb_array = temp_global?.[key] ? temp_global[key] : [];

        let filter_obj = gb_array.filter((item, index, self) =>
            self.findIndex(obj => obj.id === item.id) === index
        );

        Object.assign(temp_global, { [key]: filter_obj })
    })

    const [import_type, setimport_type] = useState('standard');
    const [global_step, setglobal_step] = useState('select');
    const [site_global_data, setsite_global_data] = useState();
    const [update_gData, setupdate_gData] = useState({ 'color': false, 'typography': false });
    const [selected_global, setselected_global] = useState();
    const [site_preset, setsite_preset] = useState();
    const [added_global, setadded_global] = useState(update_gData);
    const [popup_drp, setpopup_drp] = useState(false);
    const [final_gdata, setfinal_gdata] = useState([]);
    const [ifram, setifram] = useState(false);
    const [ifram_url, setifram_url] = useState('');
    const [update_preset, setupdate_preset] = useState(false);
    const [update_post, setupdate_post] = useState('');
    const [import_global, setimport_global] = useState();

    const iframeRef = useRef();

    useEffect(() => {
        const checkButtonAndClick = () => {
            if (iframeRef.current && iframeRef.current.contentWindow) {
                const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
                const button = iframeDoc.querySelector('.editor-post-publish-button.editor-post-publish-button__button');

                if (button) {
                    let exix_code = iframeDoc.querySelector('.components-button.is-next-40px-default-size.is-tertiary');
                    let warning_btn = iframeDoc.querySelector('.components-button.is-next-40px-default-size.is-primary');

                    if (exix_code) {
                        exix_code.click();
                        warning_btn.click();
                    } else if (warning_btn) {
                        warning_btn.click();
                    }

                    setTimeout(() => {
                        button.click();
                    }, 500);

                    setTimeout(() => {
                        check_saving();
                    }, 1000);

                    return true;
                }
            }
            return false;
        };

        const Close_popup = () => {
            const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
            const button = iframeDoc.querySelector('.editor-post-publish-button.editor-post-publish-button__button.is-busy');

            if (button) {
                return false;
            } else {
                setifram(false);
                setupdate_preset(true);

                Delete_post();
                return true;
            }
        }

        const check_saving = () => {
            const interval = setInterval(() => {
                if (Close_popup()) {
                    clearInterval(interval);
                }
            }, 500);
        };

        const startPolling = () => {
            const interval = setInterval(() => {
                if (checkButtonAndClick()) {
                    clearInterval(interval);
                }
            }, 500);
        };

        if (ifram_url) {
            startPolling();
        }
    }, [ifram_url]);

    const typography_icon = {
        'font_size': <svg className='wkit-typo-icon' xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M13.6781 4.56424L11.9776 2.29688L10.2771 4.56424H11.4107V6.8316H10.2771L11.9776 9.09896L13.6781 6.8316H12.5444V4.56424H13.6781ZM6.4832 3.43056L3.08215 12.5H4.29349L5.35632 9.6658H8.96312L10.0259 12.5H11.2373L7.83624 3.43056H6.4832ZM5.78088 8.53212L7.15943 4.85616L8.53799 8.53212H5.78088Z" fill="#1A1A1A" fillOpacity="0.5" /></svg>,
        'font_weight': <svg className='wkit-typo-icon' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.1623 3.65077C10.1623 2.46483 9.19743 1.5 8.01147 1.5H7.95052C7.56883 1.5 7.25943 1.80943 7.25943 2.19109C7.25943 2.57276 7.56885 2.88219 7.95052 2.88219H8.01147C8.43527 2.88219 8.78005 3.22694 8.78005 3.65074C8.78005 4.07455 8.43527 4.41933 8.01147 4.41933H4.11211C3.73042 4.41933 3.42102 4.72876 3.42102 5.11045C3.42102 5.49214 3.73045 5.80154 4.11211 5.80154H5.96363L5.29532 10.3101C5.24103 10.6879 5.50327 11.0381 5.88109 11.0925C5.91443 11.0973 5.94754 11.0996 5.98027 11.0996C6.3184 11.0996 6.61399 10.8511 6.66349 10.5067L7.36004 5.80157H8.01147C9.19743 5.80157 10.1623 4.83671 10.1623 3.65077Z" fill="#1A1A1A" fillOpacity="0.5" /><path d="M11.986 7.19311C11.6084 7.13886 11.2579 7.40108 11.2036 7.77887C11.1125 8.41256 11.1561 8.10926 10.992 9.25089C10.9514 9.5333 10.6847 9.77247 10.3994 9.76605C10.0512 9.7582 9.7862 9.44773 9.83609 9.10052L9.9978 7.97551C10.0521 7.59772 9.78985 7.2474 9.41208 7.19313C9.03404 7.13848 8.68398 7.40108 8.62968 7.77885L8.46797 8.90384C8.38684 9.46832 8.55446 10.0393 8.92792 10.4702C9.36612 10.9759 10.0397 11.2326 10.7229 11.1233L10.6765 11.4461C10.5575 12.2741 9.94182 12.934 9.16047 13.1388C8.85729 13.2183 8.64681 13.4936 8.64681 13.807C8.64681 14.2577 9.07179 14.5908 9.50816 14.4778C10.8213 14.1377 11.8442 13.0374 12.0447 11.6427L12.5717 7.97546C12.6261 7.59769 12.3638 7.24743 11.986 7.19311Z" fill="#1A1A1A" fillOpacity="0.5" /></svg>,
        'line_height': <svg className='wkit-typo-icon' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.79395 2.79297H13.9686" stroke="#1A1A1A" strokeOpacity="0.5" strokeWidth="1.39683" strokeLinecap="round" /><path d="M2.79395 13.9688H13.9686" stroke="#1A1A1A" strokeOpacity="0.5" strokeWidth="1.39683" strokeLinecap="round" /><path d="M6.76549 11.1773H5.58691L7.73276 5.08203H9.09586L11.2447 11.1773H10.0661L8.43812 6.33204H8.3905L6.76549 11.1773ZM6.80418 8.78741H10.0185V9.67432H6.80418V8.78741Z" fill="#1A1A1A" fillOpacity="0.5" /></svg>,
        'letter_spacing': <svg className='wkit-typo-icon' xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M3.11145 13.3268L3.11145 2.66016" stroke="#1A1A1A" strokeOpacity="0.5" strokeWidth="1.33333" strokeLinecap="round" /><path d="M13.7776 13.3268L13.7776 2.66016" stroke="#1A1A1A" strokeOpacity="0.5" strokeWidth="1.33333" strokeLinecap="round" /><path d="M6.90259 10.6658H5.77759L7.82588 4.84766H9.12702L11.1782 10.6658H10.0532L8.49918 6.04084H8.45372L6.90259 10.6658ZM6.93952 8.38459H10.0077V9.23118H6.93952V8.38459Z" fill="#1A1A1A" fillOpacity="0.5" /></svg>,
    }

    const ex_typo_icon = {
        'font_family': <svg className='wkit-typo-icon' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4 5.5V4H12V5.5M6.5 12H9.5M8 4V12" stroke="#1A1A1A" strokeOpacity="0.5" strokeLinecap="round" strokeLinejoin="round" /></svg>,
        'font_uppercase': <svg className='wkit-typo-icon' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M2.82694 12.5414C2.44987 12.5414 2.0728 12.8242 2.0728 13.2955C2.0728 13.7669 2.3556 14.0497 2.82694 14.0497V12.5414ZM8.48298 14.0497C8.86004 14.0497 9.23711 13.7669 9.23711 13.2955C9.23711 12.8242 8.95431 12.5414 8.48298 12.5414V14.0497ZM2.82694 14.0497H8.48298V12.6357H2.82694V14.0497Z" fill="black" /><path d="M5.65496 5.75414L6.31483 5.47134C6.22057 5.18853 5.93776 5 5.65496 5C5.37216 5 5.08936 5.18853 4.99509 5.47134L5.65496 5.75414ZM0.281727 16.7834C0.0931921 17.1605 0.281727 17.5376 0.658796 17.7261C1.03587 17.9146 1.41293 17.7261 1.60147 17.349L0.281727 16.7834ZM9.70846 17.349C9.89699 17.7261 10.2741 17.9146 10.6511 17.7261C11.0282 17.5376 11.2167 17.1605 11.0282 16.7834L9.70846 17.349ZM4.99509 5.47134L0.281727 16.7834L1.60147 17.349L6.31483 6.03694L4.99509 5.47134ZM11.0282 16.7834L6.31483 5.47134L4.99509 6.03694L9.70846 17.349L11.0282 16.7834Z" fill="black" /><path d="M14.873 12.5414C14.4959 12.5414 14.1188 12.8242 14.1188 13.2955C14.1188 13.7669 14.4016 14.0497 14.873 14.0497V12.5414ZM20.529 14.0497C20.9061 14.0497 21.2831 13.7669 21.2831 13.2955C21.2831 12.8242 21.0003 12.5414 20.529 12.5414V14.0497ZM14.873 14.0497H20.529V12.6357H14.873V14.0497Z" fill="black" /><path d="M17.701 5.75414L18.3609 5.47134C18.2666 5.18853 17.9838 5 17.701 5C17.4182 5 17.1354 5.18853 17.0411 5.47134L17.701 5.75414ZM12.3278 16.7834C12.1392 17.1605 12.3278 17.5376 12.7048 17.7261C13.0819 17.9146 13.459 17.7261 13.6475 17.349L12.3278 16.7834ZM21.7545 17.349C21.943 17.7261 22.3201 17.9146 22.6972 17.7261C23.0742 17.5376 23.2628 17.1605 23.0742 16.7834L21.7545 17.349ZM17.0411 5.47134L12.3278 16.7834L13.6475 17.349L18.3609 6.03694L17.0411 5.47134ZM23.0742 16.7834L18.3609 5.47134L17.0411 6.03694L21.7545 17.349L23.0742 16.7834Z" fill="black" /></svg>,
        'font_underline': <svg className='wkit-typo-icon' xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M5.2229 12.6016H13.0917V13.3328H5.2229V12.6016Z" fill="#1A1A1A" fillOpacity="0.5" /><path d="M10.9094 3.33203H12.3224V8.42809C12.3224 8.98671 12.1904 9.47803 11.9263 9.90207C11.6648 10.3261 11.2966 10.6575 10.8218 10.8961C10.3469 11.1323 9.79214 11.2504 9.15735 11.2504C8.52003 11.2504 7.96396 11.1323 7.48914 10.8961C7.01432 10.6575 6.64614 10.3261 6.38461 9.90207C6.12308 9.47803 5.99231 8.98671 5.99231 8.42809V3.33203H7.40534V8.31002C7.40534 8.63503 7.47644 8.9245 7.61863 9.17841C7.76336 9.43233 7.96649 9.63165 8.22803 9.77638C8.48956 9.91857 8.79933 9.98967 9.15735 9.98967C9.51537 9.98967 9.82515 9.91857 10.0867 9.77638C10.3508 9.63165 10.5539 9.43233 10.6961 9.17841C10.8383 8.9245 10.9094 8.63503 10.9094 8.31002V3.33203Z" fill="#1A1A1A" fillOpacity="0.5" /></svg>,
        'font_titlecase': <svg className='wkit-typo-icon' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 8.80001C19.8 8.80001 21.2 10.3 21.2 12H22.7C22.7 9.40001 20.6 7.20001 17.9 7.20001V8.80001H18ZM14.8 12C14.8 10.2 16.3 8.80001 18 8.80001V7.20001C15.4 7.20001 13.2 9.30001 13.2 12H14.8ZM18 15.2C16.2 15.2 14.8 13.7 14.8 12H13.3C13.3 14.6 15.4 16.8 18.1 16.8V15.2H18ZM18 16.8C20.6 16.8 22.8 14.7 22.8 12H21.3C21.3 13.8 19.8 15.2 18.1 15.2V16.8H18Z" fill="black" /><path d="M4.00001 11.2C3.60001 11.2 3.20001 11.5 3.20001 12C3.20001 12.5 3.50001 12.8 4.00001 12.8V11.2ZM10 12.8C10.4 12.8 10.8 12.5 10.8 12C10.8 11.5 10.5 11.2 10 11.2V12.8ZM4.00001 12.8H10V11.3H4.00001V12.8Z" fill="black" /><path d="M7.00002 4.00001L7.70002 3.70001C7.60002 3.40001 7.30002 3.20001 7.00002 3.20001C6.70002 3.20001 6.40002 3.40001 6.30002 3.70001L7.00002 4.00001ZM1.30002 15.7C1.10002 16.1 1.30002 16.5 1.70002 16.7C2.10002 16.9 2.50002 16.7 2.70002 16.3L1.30002 15.7ZM11.3 16.3C11.5 16.7 11.9 16.9 12.3 16.7C12.7 16.5 12.9 16.1 12.7 15.7L11.3 16.3ZM6.30002 3.70001L1.30002 15.7L2.70002 16.3L7.70002 4.30001L6.30002 3.70001ZM12.7 15.7L7.70002 3.70001L6.30002 4.30001L11.3 16.3L12.7 15.7Z" fill="black" /><path d="M22 16.8C21.6 16.8 21.2 16.5 21.2 16V8.00001C21.2 7.60001 21.5 7.20001 22 7.20001C22.5 7.20001 22.8 7.50001 22.8 8.00001V16C22.8 16.4 22.4 16.8 22 16.8Z" fill="black" /></svg>,
        'font_strikethrough': <svg className='wkit-typo-icon' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16.5504 7.44989C16.5504 4.93691 14.5132 2.89978 12.0003 2.89978C9.48727 2.89978 7.45014 4.93691 7.45014 7.44989C7.45014 9.96287 9.48727 12 12.0003 12C14.5132 12 16.5504 14.0371 16.5504 16.5501C16.5504 19.0631 14.5132 21.1002 12.0003 21.1002C9.48727 21.1002 7.45014 19.0631 7.45014 16.5501M4.82581 12H19.1747" stroke="black" strokeWidth="1.13281" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" /></svg>,
        'font_lowercase': <svg className='wkit-typo-icon' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 8.79995C19.8 8.79995 21.2 10.3 21.2 12H22.7C22.7 9.39995 20.6 7.19995 17.9 7.19995V8.79995H18ZM14.8 12C14.8 10.2 16.3 8.79995 18 8.79995V7.19995C15.4 7.19995 13.2 9.29995 13.2 12H14.8ZM18 15.2C16.2 15.2 14.8 13.7 14.8 12H13.3C13.3 14.6 15.4 16.8 18.1 16.8V15.2H18ZM18 16.8C20.6 16.8 22.7999 14.7 22.7999 12H21.2999C21.2999 13.8 19.8 15.2 18.1 15.2V16.8H18Z" fill="black" /><path d="M21.9999 16.8C21.5999 16.8 21.1999 16.5 21.1999 16V7.99995C21.1999 7.59995 21.4999 7.19995 21.9999 7.19995C22.4999 7.19995 22.7999 7.49995 22.7999 7.99995V16C22.7999 16.4 22.3999 16.8 21.9999 16.8Z" fill="black" /><path d="M6.8 8.79995C8.6 8.79995 10 10.3 10 12H11.5C11.5 9.39995 9.4 7.19995 6.7 7.19995V8.79995H6.8ZM3.6 12C3.6 10.2 5.1 8.79995 6.8 8.79995V7.19995C4.2 7.19995 2 9.29995 2 12H3.6ZM6.8 15.2C5 15.2 3.6 13.7 3.6 12H2.1C2.1 14.6 4.2 16.8 6.9 16.8V15.2H6.8ZM6.8 16.8C9.4 16.8 11.6 14.7 11.6 12H10.1C10.1 13.8 8.6 15.2 6.9 15.2V16.8H6.8Z" fill="black" /><path d="M10.8 16.8C10.4 16.8 9.99999 16.5 9.99999 16V7.99995C9.99999 7.59995 10.3 7.19995 10.8 7.19995C11.3 7.19995 11.6 7.49995 11.6 7.99995V16C11.6 16.4 11.2 16.8 10.8 16.8Z" fill="black" /></svg>,
    }

    const Delete_post = async () => {
        let form = new FormData();
        form.append("action", "get_wdesignkit");
        form.append("kit_nonce", wdkitData.kit_nonce);
        form.append("type", "update_preset_setting");
        form.append("act_type", "remove");
        form.append("post_id", update_post);

        await axios.post(ajaxurl, form)
    }

    const Select_type = () => {
        return (
            <div className="kit-type-flex">
                <div className={`wkit-import-type ${import_type == 'standard' ? 'wkit-selected-type' : ''}`} onClick={() => { setimport_type('standard') }}>
                    <div className='wkit-import-type-select'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
                            <path d="M14.2223 1.33331L5.66672 9.88887L1.77783 5.99998" stroke="white" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className='wkit-import-option'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M0.199463 4.63146C0.199463 2.61239 1.83624 0.975616 3.85531 0.975616H20.5904C22.6094 0.975616 24.2462 2.61239 24.2462 4.63146V8.11793V21.3665C24.2462 23.3856 22.6094 25.0224 20.5904 25.0224H3.85531C1.83624 25.0224 0.199463 23.3856 0.199463 21.3665V8.11793V4.63146ZM3.85531 2.70895C2.79353 2.70895 1.9328 3.56969 1.9328 4.63146V7.25127H22.5129V4.63146C22.5129 3.56969 21.6521 2.70895 20.5904 2.70895H3.85531ZM22.5129 8.9846H1.9328V21.3665C1.9328 22.4283 2.79353 23.289 3.85531 23.289H20.5904C21.6521 23.289 22.5129 22.4283 22.5129 21.3665V8.9846ZM2.98864 12.999C2.98864 12.5203 3.37666 12.1323 3.85531 12.1323L20.5904 12.1323C21.069 12.1323 21.457 12.5203 21.457 12.999C21.457 13.4776 21.069 13.8657 20.5904 13.8657L3.85531 13.8657C3.37666 13.8657 2.98864 13.4776 2.98864 12.999ZM3.86398 5.3264C3.86398 4.9413 4.17617 4.62911 4.56128 4.62911C4.94638 4.62911 5.25857 4.9413 5.25857 5.3264C5.25857 5.71151 4.94638 6.0237 4.56128 6.0237C4.17617 6.0237 3.86398 5.71151 3.86398 5.3264ZM7.35034 4.63021C6.96523 4.63021 6.65304 4.9424 6.65304 5.3275C6.65304 5.71261 6.96523 6.0248 7.35034 6.0248C7.73544 6.0248 8.04763 5.71261 8.04763 5.3275C8.04763 4.9424 7.73544 4.63021 7.35034 4.63021ZM4.7356 16.1365C4.25422 16.1365 3.86398 16.5268 3.86398 17.0081V18.7514C3.86398 19.2327 4.25422 19.623 4.7356 19.623H6.47884C6.96022 19.623 7.35045 19.2327 7.35045 18.7514V17.0081C7.35045 16.5268 6.96022 16.1365 6.47884 16.1365H4.7356ZM11.3308 16.1365C10.8495 16.1365 10.4592 16.5268 10.4592 17.0081V18.7514C10.4592 19.2327 10.8495 19.623 11.3308 19.623H13.0741C13.5555 19.623 13.9457 19.2327 13.9457 18.7514V17.0081C13.9457 16.5268 13.5555 16.1365 13.0741 16.1365H11.3308ZM17.1126 17.0081C17.1126 16.5268 17.5028 16.1365 17.9842 16.1365H19.7274C20.2088 16.1365 20.599 16.5268 20.599 17.0081V18.7514C20.599 19.2327 20.2088 19.623 19.7274 19.623H17.9842C17.5028 19.623 17.1126 19.2327 17.1126 18.7514V17.0081ZM10.1348 4.63021C9.74974 4.63021 9.43755 4.9424 9.43755 5.3275C9.43755 5.71261 9.74974 6.0248 10.1348 6.0248C10.5199 6.0248 10.8321 5.71261 10.8321 5.3275C10.8321 4.9424 10.5199 4.63021 10.1348 4.63021Z" fill="#040483" />
                        </svg>
                        <span className='wkit-import-opt-title'>{__('Standard Style', 'wdesignkit')}</span>
                        <span className='wkit-import-opt-desc'>{__('Standard Import', 'wdesignkit')}</span>
                    </div>
                </div>
                <div className={`wkit-import-type ${import_type == 'global' ? 'wkit-selected-type' : ''}`} onClick={() => { setimport_type('global') }}>
                    <div className='wkit-import-type-select'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
                            <path d="M14.2223 1.33331L5.66672 9.88887L1.77783 5.99998" stroke="white" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className='wkit-import-option'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path d="M16.0001 29.3333C23.3639 29.3333 29.3334 23.3638 29.3334 16C29.3334 8.63619 23.3639 2.66666 16.0001 2.66666C8.63628 2.66666 2.66675 8.63619 2.66675 16C2.66675 23.3638 8.63628 29.3333 16.0001 29.3333Z" stroke="#040483" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2.66675 16H29.3334" stroke="#040483" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M16.0001 2.66666C19.3351 6.31779 21.2304 11.056 21.3334 16C21.2304 20.9439 19.3351 25.6822 16.0001 29.3333C12.665 25.6822 10.7697 20.9439 10.6667 16C10.7697 11.056 12.665 6.31779 16.0001 2.66666Z" stroke="#040483" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span className='wkit-import-opt-title'>{__('Global Style', 'wdesignkit')}</span>
                        <span className='wkit-import-opt-desc'>{__('Import with Global Color', 'wdesignkit')}</span>
                    </div>
                </div>
            </div>
        );
    }

    const Show_global_data = () => {
        return (
            <div className="kit-type-flex">
                <div className='wkit-show-global'>
                    {temp_global && Object.values(temp_global).length > 0 &&
                        Object.entries(temp_global).map(([g_key, g_data], index) => {
                            if (g_key == 'color' || g_key == 'typography') {
                                if (g_data?.length > 0) {
                                    return (
                                        <div className={`wkit-show-global-color ${site_preset ? '' : 'wkit-skeleton'}`} key={index}>
                                            <div className='wkit-show-global-header'>
                                                <div className='wkit-show-global-txt'>
                                                    <span className='wkit-show-global-title'>{__(`Global ${g_key}`, 'wdesignkit')}</span>
                                                    <span className='wkit-show-global-desc'>{__(`Total  global ${g_key} we found from Template`, 'wdesignkit')}</span>
                                                </div>
                                                {added_global?.[g_key] ? <span className='wkit-global-added'>
                                                    <svg className="wkit-global-success-svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M9.24735 0.0195866C7.79655 0.156374 6.69379 0.465122 5.48936 1.07089C3.9017 1.86425 2.43135 3.21257 1.46546 4.76021C0.76548 5.87796 0.257115 7.32008 0.0498588 8.7661C-0.0166196 9.22727 -0.0166196 10.7671 0.0498588 11.2283C0.2141 12.3812 0.519118 13.3895 0.996199 14.3548C1.53194 15.4491 2.05985 16.1838 2.92798 17.0554C3.7922 17.9152 4.53911 18.4506 5.59103 18.9665C6.3262 19.326 6.79938 19.5019 7.54628 19.6895C9.50153 20.1819 11.4646 20.0881 13.3729 19.412C13.9595 19.2049 14.9684 18.6968 15.4846 18.3529C16.6656 17.5634 17.7253 16.477 18.4918 15.2732C18.7733 14.8316 19.2269 13.8936 19.4107 13.3739C20.3297 10.7866 20.1694 8.01182 18.961 5.58484C18.4761 4.60779 17.9326 3.83788 17.17 3.05234C16.3332 2.18472 15.4885 1.57114 14.3896 1.0279C13.2321 0.457304 12.1528 0.148558 10.8702 0.031311C10.4713 -0.00386238 9.56801 -0.0116787 9.24735 0.0195866Z" fill="#14C38E"></path>
                                                        <path d="M13.8261 6.73158C13.7733 6.75427 12.4461 8.05869 10.8776 9.63534L8.01967 12.4975L6.95643 11.4313C5.80646 10.2819 5.79892 10.2781 5.46712 10.3424C5.28238 10.3764 5.05615 10.6033 5.02222 10.7885C4.95812 11.1288 4.9355 11.1023 6.39087 12.5618C7.84624 14.0212 7.81607 13.9985 8.15918 13.9343C8.28737 13.9116 8.65687 13.5562 11.4432 10.7658C13.7243 8.47837 14.5914 7.58607 14.6216 7.49155C14.7046 7.23822 14.6141 6.966 14.3841 6.79586C14.2672 6.70889 13.9656 6.67487 13.8261 6.73158Z" fill="white"></path>
                                                    </svg>
                                                    {__(`${g_data.length} new global color added successfully to your style.`, 'wdesignkit')}
                                                </span>
                                                    :
                                                    update_gData?.[g_key] ?
                                                        <div className='wkit-global-submit-btn wkit-outer-btn-class'>
                                                            <svg xmlns="http://www.w3.org/2000/svg" style={{ animation: 'spin 1.5s linear infinite' }} width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M4.73221 20.7144C6.1457 20.7144 7.29156 19.5686 7.29156 18.1551C7.29156 16.7416 6.1457 15.5957 4.73221 15.5957C3.31871 15.5957 2.17285 16.7416 2.17285 18.1551C2.17285 19.5686 3.31871 20.7144 4.73221 20.7144Z" fill="#040483" />
                                                                <path d="M21.1989 18.4446C22.4257 18.4446 23.4202 17.4501 23.4202 16.2233C23.4202 14.9965 22.4257 14.002 21.1989 14.002C19.9721 14.002 18.9775 14.9965 18.9775 16.2233C18.9775 17.4501 19.9721 18.4446 21.1989 18.4446Z" fill="#B1B1D9" />
                                                                <path d="M19.1709 7.24619C20.1844 7.24619 21.006 6.42463 21.006 5.41118C21.006 4.39773 20.1844 3.57617 19.1709 3.57617C18.1575 3.57617 17.3359 4.39773 17.3359 5.41118C17.3359 6.42463 18.1575 7.24619 19.1709 7.24619Z" fill="#B1B1D9" />
                                                                <path d="M2.71606 14.4677C4.21609 14.4677 5.43211 13.2813 5.43211 11.8178C5.43211 10.3543 4.21609 9.16797 2.71606 9.16797C1.21602 9.16797 0 10.3543 0 11.8178C0 13.2813 1.21602 14.4677 2.71606 14.4677Z" fill="#040483" />
                                                                <path d="M10.518 23.9976C11.8817 23.9976 12.9871 22.9204 12.9871 21.5916C12.9871 20.2628 11.8817 19.1855 10.518 19.1855C9.1543 19.1855 8.04883 20.2628 8.04883 21.5916C8.04883 22.9204 9.1543 23.9976 10.518 23.9976Z" fill="#B1B1D9" />
                                                                <path d="M16.8642 22.9429C18.1597 22.9429 19.2099 21.9204 19.2099 20.659C19.2099 19.3976 18.1597 18.375 16.8642 18.375C15.5687 18.375 14.5186 19.3976 14.5186 20.659C14.5186 21.9204 15.5687 22.9429 16.8642 22.9429Z" fill="#B1B1D9" />
                                                                <path d="M5.65394 8.31486C7.22214 8.31486 8.49342 7.07393 8.49342 5.54317C8.49342 4.01241 7.22214 2.77148 5.65394 2.77148C4.08573 2.77148 2.81445 4.01241 2.81445 5.54317C2.81445 7.07393 4.08573 8.31486 5.65394 8.31486Z" fill="#040483" />
                                                                <path d="M21.9005 12.5103C23.0596 12.5103 23.9993 11.5881 23.9993 10.4505C23.9993 9.31285 23.0596 8.39062 21.9005 8.39062C20.7414 8.39062 19.8018 9.31285 19.8018 10.4505C19.8018 11.5881 20.7414 12.5103 21.9005 12.5103Z" fill="#B1B1D9" />
                                                                <path d="M12.7 5.98793C14.3535 5.98793 15.694 4.64748 15.694 2.99396C15.694 1.34044 14.3535 0 12.7 0C11.0465 0 9.70605 1.34044 9.70605 2.99396C9.70605 4.64748 11.0465 5.98793 12.7 5.98793Z" fill="#040483" />
                                                            </svg>
                                                        </div>
                                                        :
                                                        <div className='wkit-global-submit-btn wkit-outer-btn-class' onClick={() => { Upload_global_data(g_key) }}>{__(`Add missing ${g_data.length} global ${g_key}`, 'wdesignkit')}</div>
                                                }
                                            </div>

                                            {Global_data_card(g_key, g_data)}
                                        </div>
                                    );
                                }
                            }
                        })
                    }
                </div>
            </div>
        );
    }

    const Global_data_card = (type, card_array) => {
        let g_loop = (card_array?.length > 0) ? card_array : [];

        return (
            <div className='wkit-show-global-list'>
                {g_loop.map((g_data, index) => {
                    let selected_idx = final_gdata?.[type]?.findIndex((data) => data?.temp_id == g_data?.id)
                    if (type == 'color') {
                        return (
                            <button key={index} className={`wkit-show-global-card ${(selected_idx > -1) ? 'wkit-selected_value' : ''}`} disabled={added_global?.[type]} onClick={() => { setglobal_step('inner'), setselected_global({ 'value': g_data, 'type': type }) }}>
                                {(selected_idx > -1) &&
                                    <svg className='wkit-global-selected-tick' xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 8 6" fill="none">
                                        <path d="M6.59241 1.05664L3.0276 4.62146L1.40723 3.00108" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }
                                <span className='wkit-global-card-tooltip'>{g_data.label}</span>
                                <div className='wkit-global-card-content'>
                                    <span className='wkit-global-card-dot wkit-circle-border' style={{ background: g_data.value }}></span>
                                    <span className='wkit-global-card-val'>{g_data.value}</span>
                                </div>
                            </button>
                        );
                    } else if (type == 'typography') {
                        let typo_data = g_data?.value ? g_data.value : '';
                        let font_family = typo_data?.fontFamily?.family ? typo_data.fontFamily.family : '';
                        let font_size = typo_data?.size ? typo_data.size : '';
                        let fs_val = font_size ? font_size.md + font_size.unit + ' - ' : '';
                        let font_weight = typo_data?.fontFamily?.fontWeight ? typo_data.fontFamily.fontWeight : '';
                        let typo_text = fs_val + font_weight;

                        return (
                            <button key={index} className={`wkit-show-global-card ${(selected_idx > -1) ? 'wkit-selected_value' : ''}`} disabled={added_global?.[type]} onClick={() => { setglobal_step('inner'), setselected_global({ 'value': g_data, 'type': type }) }}>
                                {(selected_idx > -1) &&
                                    <svg className='wkit-global-selected-tick' xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 8 6" fill="none">
                                        <path d="M6.59241 1.05664L3.0276 4.62146L1.40723 3.00108" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }
                                <span className='wkit-global-card-tooltip'>{g_data.label}</span>
                                <div className='wkit-global-card-content'>
                                    <span className='wkit-global-card-dot' style={{ fontFamily: font_family, fontWeight: font_weight }}>{__('Ag', 'wdesignkit')}</span>
                                    <span className='wkit-global-card-val'>{typo_text}</span>
                                </div>
                            </button>
                        );
                    }
                })}
            </div>
        );
    }

    const create_global_obj = async (type) => {
        setifram(true);

        var add_global = { 'color': [], 'typography': [] }
        if (Object.entries(temp_global).length > 0) {
            var new_global = { 'color': [], 'typography': [] }

            Object.entries(temp_global).map(([g_key, g_val]) => {
                let site_global = site_global_data?.[g_key] ? site_global_data[g_key] : [];
                let replace_global = final_gdata?.[g_key] ? final_gdata[g_key] : [];

                let data_array = [];
                if (g_val.length > 0) {
                    g_val.map((global_data) => {
                        var globals = Object.assign({}, global_data, { 'id': global_data.id });
                        let temp_gid = globals?.id ? globals.id : '';
                        let replace_idx = replace_global.findIndex((data) => data?.temp_id == temp_gid)

                        if (replace_idx > -1) {
                            let site_id = replace_global[replace_idx]?.site_id;
                            let site_idx = site_global.findIndex((data) => data?.id == site_id);

                            var new_obj = { 'status': 'update', 'temp_id': globals?.id, 'site_id': site_id, 'data': site_global[site_idx] }
                        }
                        // else if (site_idx > -1) {
                        //     var new_obj = { 'status': 'done', 'temp_id': globals?.id }
                        // }
                        else if (import_type == 'standard') {
                            var new_obj = { 'status': 'remove', 'temp_id': globals?.id, 'data': globals }
                        } else if (import_type == 'global') {
                            if (add_global?.[g_key]) {
                                add_global?.[g_key].push(globals);

                                let preset_key = site_preset?.[g_key] ? site_preset?.[g_key] : [];
                                var new_obj = { 'status': 'update', 'temp_id': globals?.id, 'site_id': (preset_key.length + 1), 'data': globals }
                                delete globals.id;
                                preset_key.push(globals);

                            } else {
                                var new_obj = { 'status': 'remove', 'temp_id': globals?.id, 'data': globals }
                            }
                        }

                        data_array.push(new_obj)
                    })
                }

                Object.assign(new_global, { [g_key]: data_array });
            })

            let global_color = add_global?.color?.length > 0 ? add_global.color : [];
            let global_typography = add_global?.typography?.length > 0 ? add_global.typography : []

            if (global_color.length > 0 || global_typography.length > 0) {

                let new_preset = Object.assign({}, site_preset, { 'key': 'wdk_preset', 'name': 'WDK Preset', 'colors': site_preset.color });
                delete new_preset.color;

                let confirmation = window.confirm(__("The global color and typography you haven't selected will be added as new in your site. Do you want to proceed ?", 'wdesignkit'));

                if (confirmation == true) {

                    let form = new FormData();
                    form.append("action", "get_wdesignkit");
                    form.append("kit_nonce", wdkitData.kit_nonce);
                    form.append("type", "update_global_val");
                    form.append("builder", "gutenberg");
                    form.append('new_preset', JSON.stringify(new_preset));

                    await axios.post(ajaxurl, form).then((res) => { })

                    setimport_global(new_global);
                }
            } else {
                setimport_global(new_global);
            }

        }

        if (type == 'standard') {
            props.import_template(new_global);
        } else {
            update_setting();
        }
    }

    const update_setting = async () => {

        let form = new FormData();
        form.append("action", "get_wdesignkit");
        form.append("kit_nonce", wdkitData.kit_nonce);
        form.append("type", "update_preset_setting");
        form.append("act_type", "create");

        await axios.post(ajaxurl, form).then(async (res) => {
            if (res.data?.success) {
                setifram_url(res?.data?.preview_url)
                setupdate_post(res.data.post_id);
            }
        })

    }

    const Next_import_btn = () => {

        if (global_step == 'global') {
            if (update_preset) {
                var btn_name = __('Import', 'wdesignkit');
            } else {
                var btn_name = __('Update Settings', 'wdesignkit');
            }
        } else if (import_type == 'standard') {
            var btn_name = __('Import', 'wdesignkit');
        } else if (import_type == 'global') {
            var btn_name = __('Next', 'wdesignkit');
        }

        const next_button = () => {
            if (import_global) {
                props.import_template(import_global);
                setsite_preset();
                setimport_global();
                setupdate_preset();
                return false;
            }

            if (global_step == 'global') {
                create_global_obj();
            } else if (import_type == 'standard') {
                create_global_obj('standard');
            } else if (import_type == 'global') {
                setglobal_step(import_type);

                let form = new FormData();
                form.append("action", "get_wdesignkit");
                form.append("kit_nonce", wdkitData.kit_nonce);
                form.append("type", "get_global_val");
                form.append("builder", 'gutenberg');

                axios.post(ajaxurl, form).then(async (res) => {
                    if (res?.data?.success && res?.data?.data) {
                        let site_data = res?.data?.data ? res.data.data : '';
                        setsite_preset(site_data);

                        if (site_data?.colors) {
                            Object.assign(site_data, { 'color': site_data?.colors });

                            delete site_data.colors;
                        }

                        if (Object.entries(site_data).length > 0) {
                            let s_data = Object.entries(site_data);

                            s_data.map(([key, value]) => {

                                if (typeof value == 'array' || typeof value == 'object') {
                                    let new_val = [];

                                    value.map((val, index) => {
                                        let new_obj = Object.assign({}, val, { 'id': (index + 1) })
                                        new_val.push(new_obj);
                                    })

                                    site_data = Object.assign({}, site_data, { [key]: new_val })
                                }
                            })
                        }

                        setsite_global_data(site_data);
                    }
                });
            }
        }

        if (global_step != 'inner') {
            return (
                <div className='wkit-next-step-second wkit-global-step-notice'>
                    <div className="wkit-remove-plugin-notice">
                        <span className="wkit-notice-text">
                            <b className="wkit-bold-text">{__('Note:', 'wdesignkit')}</b>
                            {__('This will apply universal design elements, including typography, colors, spacing, and component styling, across all projects. Ensure compatibility with existing styles to maintain design consistency.', 'wdesignkit')}
                        </span>
                    </div>

                    {(global_step == 'global') ?
                        <>
                            {ifram ?
                                <button className={'wkit-loading-button wkit-btn-class'} >
                                    <div className="wkit-update-loader">
                                        <div className="wkit-update-loader-circle"></div>
                                    </div>
                                </button>
                                :
                                (site_preset &&
                                    <button className={'wkit-update-preset-btn wkit-btn-class'} onClick={(e) => { next_button() }} disabled={update_gData.color || update_gData.typography}>{btn_name}</button>
                                )
                            }
                        </>
                        :
                        <button className={'wkit-next-step wkit-btn-class'} onClick={(e) => { next_button() }} disabled={update_gData.color || update_gData.typography}>{btn_name}</button>
                    }
                </div>
            );
        }
    }

    const Upload_global_data = (type) => {

        setupdate_gData((prev) => ({ ...prev, [type]: true, }));

        let upload_data = temp_global?.[type] ? temp_global?.[type] : [];
        var unique_global = site_global_data?.[type] ? site_global_data[type] : [];
        let preset_key = site_preset?.[type] ? site_preset?.[type] : [];

        if (upload_data.length > 0) {
            let update_array = final_gdata?.[type] ? final_gdata[type] : [];
            upload_data.map((new_data) => {

                let add_obj = Object.assign({}, new_data, { 'id': (Number(unique_global.length) + 1) });
                var new_obj = { 'temp_id': new_data?.id, 'site_id': (Number(unique_global.length) + 1) }
                update_array.push(new_obj);
                unique_global.push(add_obj);
                preset_key.push(add_obj)

            })

            let new_global = Object.assign({}, final_gdata, { [type]: update_array });
            setfinal_gdata(new_global);
        }

        let new_preset = Object.assign({}, site_preset, { 'key': 'wdk_preset', 'name': 'WDK Preset', 'colors': site_preset?.color });
        delete new_preset.color;

        let form = new FormData();
        form.append("action", "get_wdesignkit");
        form.append("kit_nonce", wdkitData.kit_nonce);
        form.append("type", "update_global_val");
        form.append("builder", "gutenberg");
        form.append('new_preset', JSON.stringify(new_preset));
        axios.post(ajaxurl, form).then(async (res) => {

            if (res?.data?.success) {
                setupdate_gData((prev) => ({ ...prev, [type]: false, }));
                setadded_global((prev) => ({ ...prev, [type]: true, }));

                if (unique_global.length > 0) {
                    let update_data = Object.assign({}, site_global_data, { [type]: unique_global });
                    setsite_global_data(update_data)
                }
            } else {
                setupdate_gData((prev) => ({ ...prev, [type]: false, }));
            }
        });
    }

    const drp_close_event = (event) => {
        let drp_head = event.target.closest('.wkit-select-global-header');

        if (!drp_head) {
            setpopup_drp(false);
        }
    }

    const replace_global_data = (site_data) => {

        let temp_type = selected_global?.type ? selected_global.type : '';
        let temp_data = selected_global?.value ? selected_global.value : '';
        let current_data = final_gdata?.[temp_type] ? final_gdata?.[temp_type] : [];

        let index = current_data.findIndex((data) => data.temp_id == temp_data?.id)
        if (index > -1) {
            current_data.splice(index, 1, { 'temp_id': temp_data?.id, 'site_id': site_data.id })
        } else {
            current_data.push({ 'temp_id': temp_data?.id, 'site_id': site_data.id })
        }

        let update = Object.assign({}, final_gdata, { [temp_type]: current_data })

        setfinal_gdata(update)
    }

    const Show_inner_popup = () => {
        let key = selected_global?.type ? selected_global.type : '';
        let global_data = selected_global?.value ? selected_global.value : '';

        let typo_data = global_data?.value ? global_data.value : '';
        let font_family = typo_data?.fontFamily?.family ? typo_data.fontFamily.family : '';
        let font_size = typo_data?.size ? typo_data.size : '';
        let fs_val = font_size ? font_size.md + font_size.unit + ' - ' : '';
        let font_weight = typo_data?.fontFamily?.fontWeight ? typo_data.fontFamily.fontWeight : '';
        let typo_text = fs_val + font_weight;

        const selected_data_btn = () => {
            let select_data = final_gdata?.[key] ? final_gdata[key] : [];
            let index = select_data.findIndex((data) => data.temp_id == global_data.id);

            if (index > -1) {
                let site_id = select_data[index]?.site_id;
                let global_data = site_global_data?.[key] ? site_global_data[key] : [];
                let site_idx = global_data.findIndex((data) => data.id == site_id)

                var replace_data = global_data?.[site_idx] ? global_data?.[site_idx] : '';
            }

            let typo_replace_data = replace_data?.value ? replace_data.value : '';
            let font_family = typo_data?.fontFamily?.family ? typo_data.fontFamily.family : '';
            let font_size = typo_data?.size ? typo_data.size : '';
            let fs_val = font_size ? font_size.md + font_size.unit + ' - ' : '';
            let font_weight = typo_data?.fontFamily?.fontWeight ? typo_data.fontFamily.fontWeight : '';
            let typo_text = fs_val + font_weight;

            return (
                <div className='wkit-inner-popup-footer'>
                    {key == 'typography' &&
                        <div className='wkit-global-replace-data'>
                            {replace_data &&
                                <div className='wkit-popup-submit-btn'>
                                    <div className='wkit-global-replace-val'>
                                        <span className='wkit-global-card-dot' style={{ fontFamily: font_family, fontWeight: font_weight }}>{__('Ag', 'wdesignkit')}</span>
                                        <span className='wkit-global-card-val'>{typo_text}</span>
                                    </div>
                                    <span className='wkit-replace-global-txt'>{__('Replace with', 'wdesignkit')}</span>
                                    <div className='wkit-global-site-val'>
                                        <span className='wkit-global-card-dot' style={{ fontFamily: typo_replace_data.fontFamily.family, fontWeight: typo_replace_data.fontFamily.fontWeight }}>{__('Ag', 'wdesignkit')}</span>
                                        <span className='wkit-global-card-val'>{typo_replace_data?.size?.md + typo_replace_data?.size?.unit + " - " + typo_replace_data.fontFamily.fontWeight}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    {key == 'color' &&
                        <div className='wkit-global-replace-data'>
                            {replace_data &&
                                <div className='wkit-popup-submit-btn'>
                                    <div className='wkit-global-replace-val'>
                                        <span className='wkit-selected-color-box' style={{ background: global_data.value }}></span>
                                        <span className='wkit-selected-color-txt'>{global_data.value}</span>
                                    </div>
                                    <span className='wkit-replace-global-txt'>{__('Replace with', 'wdesignkit')}</span>
                                    <div className='wkit-global-site-val'>
                                        <span className='wkit-replace-color-box' style={{ background: replace_data.value }}></span>
                                        <span className='wkit-replace-color-txt'>{replace_data.value}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className='wkit-global-inner-back'>
                        <button className='wkit-outer-btn-class' onClick={(e) => { setglobal_step('global') }}>{__('Back', 'wdesignkit')}</button>
                    </div>
                </div>
            );
        }

        return (
            <>
                <div className='wkit-inner-popup-body' onClick={(e) => { drp_close_event(e) }}>
                    <div className='wkit-selected-global-value'>
                        <span className='wkit-selected-title'>{global_data.label}</span>
                        {key == 'color' &&
                            <div className='wkit-select-global-dpr'>
                                <div className='wkit-select-global-header' onClick={() => { setpopup_drp(!popup_drp) }}>
                                    <span className='wkit-global-card-dot wkit-circle-border' style={{ background: global_data.value }}></span>
                                    <span className='wkit-global-card-val'>{global_data.value}</span>
                                    <svg width="18" height="18" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.5 3.75L5 6.25L7.5 3.75" stroke="#040483" strokeWidth="0.625" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                {popup_drp &&
                                    <div className='wkit-select-global-body'>
                                        {temp_global.color.map((tm_glb, index) => {
                                            return (
                                                <div className='wkit-select-body-cn' onClick={() => { setselected_global({ 'value': tm_glb, 'type': 'color' }) }} key={index}>
                                                    <span className='wkit-global-card-dot wkit-circle-border' style={{ background: tm_glb.value }}></span>
                                                    <span className='wkit-global-card-val'>{tm_glb.value}</span>
                                                </div>
                                            );
                                        })
                                        }
                                    </div>
                                }
                            </div>
                        }
                        {key == 'typography' &&
                            <div className='wkit-select-global-dpr'>
                                <div className='wkit-select-global-header' onClick={() => { setpopup_drp(!popup_drp) }}>
                                    <span className='wkit-global-card-dot' style={{ fontFamily: font_family, fontWeight: font_weight }}>{__('Ag', 'wdesignkit')}</span>
                                    <span className='wkit-global-card-val'>{typo_text}</span>
                                    <svg width="18" height="18" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.5 3.75L5 6.25L7.5 3.75" stroke="#040483" strokeWidth="0.625" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                {popup_drp &&
                                    <div className='wkit-select-global-body'>
                                        {temp_global.typography.map((tm_glb, index) => {
                                            let typo_data = tm_glb?.value ? tm_glb.value : '';

                                            let t_font_family = typo_data?.fontFamily?.family ? typo_data.fontFamily.family : '';
                                            let t_font_weight = typo_data?.fontFamily?.fontWeight ? typo_data.fontFamily.fontWeight : '';
                                            let t_font_size = typo_data?.size?.md ? typo_data.size.md : '';
                                            let t_font_unit = typo_data?.size?.unit ? typo_data.size.unit : '';

                                            return (
                                                <div className='wkit-select-body-cn' onClick={() => { setselected_global({ 'value': tm_glb, 'type': 'typography' }) }} key={index}>
                                                    <span className='wkit-global-card-dot' style={{ fontFamily: t_font_family, fontWeight: t_font_weight }}>{__('Ag', 'wdesignkit')}</span>
                                                    <span className='wkit-global-card-val'>{t_font_size + t_font_unit + " - " + t_font_weight}</span>
                                                </div>
                                            );
                                        })
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    <hr />
                    <div className={`wkit-global-${key}-options`}>
                        {site_global_data?.[key]?.length > 0 &&
                            site_global_data[key].map((sg_data, index) => {
                                let indx = final_gdata?.[key]?.findIndex((data) => data?.temp_id == global_data?.id);

                                if (indx > -1) {
                                    var val = final_gdata?.[key]?.[indx]?.site_id;
                                }
                                if (key == 'color') {
                                    return (
                                        <div className={`wkit-show-global-card ${(val == sg_data?.id) ? 'wkit-selected_value' : ''}`} onClick={() => { replace_global_data(sg_data) }} key={index}>
                                            {(val == sg_data?.id) &&
                                                <svg className='wkit-global-selected-tick' xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 8 6" fill="none">
                                                    <path d="M6.59241 1.05664L3.0276 4.62146L1.40723 3.00108" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            }
                                            <div className='wkit-global-card-content'>
                                                <span className='wkit-global-card-dot wkit-circle-border' style={{ background: sg_data.value }}></span>
                                                <span className='wkit-global-card-val'>{sg_data.value}</span>
                                            </div>
                                        </div>
                                    );
                                } else if (key == 'typography') {
                                    let typo_data = sg_data?.value ? sg_data.value : '';
                                    let t_font_family = typo_data?.fontFamily?.family ? typo_data.fontFamily.family : '';
                                    let t_font_size = typo_data?.size ? typo_data.size : '';
                                    let t_font_height = typo_data?.height ? typo_data.height : '';
                                    let t_font_spacing = typo_data?.spacing ? typo_data.spacing : '';

                                    const t_data = {
                                        'font_weight': typo_data?.fontFamily?.fontWeight ? typo_data.fontFamily.fontWeight : '',
                                        'font_size': t_font_size ? t_font_size?.md + t_font_size?.unit : '',
                                        'line_height': t_font_height ? t_font_height?.md + t_font_height?.unit : '',
                                        'letter_spacing': t_font_spacing ? t_font_spacing?.md + t_font_spacing?.unit : '',
                                    }

                                    return (
                                        <div className={`wkit-show-global-card ${(val == sg_data?.id) ? 'wkit-selected_value' : ''}`} onClick={() => { replace_global_data(sg_data) }} key={index}>
                                            {(val == sg_data?.id) &&
                                                <svg className='wkit-global-selected-tick' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 8 6" fill="none">
                                                    <path d="M6.59241 1.05664L3.0276 4.62146L1.40723 3.00108" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            }
                                            <div className='wkit-global-typo-fontfamily'>
                                                {ex_typo_icon.font_family}
                                                <span style={{ fontFamily: t_font_family }}>{t_font_family}</span>
                                            </div>
                                            <div className='wkit-global-card-typo' >
                                                {Object.entries(typography_icon).map(([key, value], index) => {
                                                    return (
                                                        <div className='wkit-typo-detail' key={index}>
                                                            {value}
                                                            {t_data?.[key] ?
                                                                <span>{t_data?.[key]}</span>
                                                                :
                                                                <span>NaN</span>
                                                            }
                                                        </div>
                                                    );
                                                })
                                                }
                                            </div>
                                        </div>
                                    );
                                }
                            })
                        }
                    </div>
                </div>
                {selected_data_btn()}
            </>
        );
    }

    return (
        <Fragment>
            <div className="wkit-popup-header">{__('Import Templates', 'wdesignkit')}</div>
            <div className="wkit-popup-body">

                {global_step == 'select' &&
                    <Select_type />
                }

                {global_step == 'global' &&
                    Show_global_data()
                }

                {global_step == 'inner' && selected_global &&
                    Show_inner_popup()
                }
                <Next_import_btn />
                {ifram && ifram_url &&
                    <iframe id='wkit-edit-link-ifram' ref={iframeRef} src={ifram_url} />
                }
            </div>
        </Fragment>
    );
}

export const Extract_gutenberg_global = (content, global_data) => {

    var tmp_content = content;

    let regex = /<!--\s*wp:[^\s]+\s*(?:({[\s\S]*?}))?\s*(?:\/-->|-->)/g;

    let matches = [...content.matchAll(regex)];

    let blockObjects = matches.map((match) => {

        try {
            return JSON.parse(match[1]);
        } catch (e) {
            return null;
        }

    }).filter(obj => obj !== null);

    const traverse = (obj) => {
        if (Array.isArray(obj)) {
            return obj.map(item => traverse(item));
        } else if (typeof obj === "object" && obj !== null) {
            var new_data = { ...obj };

            Object.entries(new_data).map(([key, value]) => {

                if (typeof value === "string" && value.startsWith("var(")) {
                    let match = value.match(/var\(--tpgb-([A-Z]+)([A-Z0-9]*)\)/i);

                    if (match) {
                        if (match[1] == 'C') {

                            let index = global_data?.color?.findIndex((c_data) => (Number(c_data.temp_id) + 1) == match[2])
                            let temp_global = global_data?.color?.[index];

                            if (temp_global?.status == 'update') {
                                var g_value = `var(--tpgb-C${temp_global.site_id})`;
                            } else if (temp_global?.status == 'remove') {
                                var g_value = temp_global.data.value;
                            }

                            var g_var2 = `var(--tpgb-C${match[2]})`;
                            tmp_content = tmp_content.replaceAll(g_var2, g_value)

                            if (index > -1) {
                                Object.assign(new_data, { [key]: g_value });
                            }
                        } else if (match[1] == 'GC') {
                            let index = global_data?.gradient?.findIndex((c_data) => (Number(c_data.temp_id) + 1) == match[2])
                            let g_value = global_data?.gradient?.[index].data.value;

                            var g_var2 = `var(--tpgb-GC${match[2]})`;
                            tmp_content = tmp_content.replaceAll(g_var2, g_value)

                            if (index > -1) {
                                Object.assign(new_data, { [key]: g_value });
                            }
                        } else if (match[1] == 'S') {
                            let index = global_data?.spacing?.findIndex((c_data) => (Number(c_data.temp_id) + 1) == match[2])
                            let g_value = global_data?.spacing?.[index].data.value

                            if (index > -1) {
                                Object.assign(new_data, { [key]: g_value });
                            }
                        }
                    }
                }

                if (key.toLowerCase().includes("global") && (key === "globalTypo" || key === "globalShadow")) {

                    if (new_data?.[key]) {
                        delete new_data[key];
                    }

                    if (key === "globalShadow") {
                        let index = global_data.boxshadow.findIndex((c_data) => (Number(c_data.temp_id) + 1) == value)
                        let bs_data = global_data.boxshadow[index].data.value

                        if (bs_data?.inset == 0) {
                            var shadow_val = `${bs_data?.horizontal}px ${bs_data?.vertical}px ${bs_data?.blur}px ${bs_data?.spread}px ${bs_data?.color}`
                        } else {
                            var shadow_val = `inset ${bs_data?.horizontal}px ${bs_data?.vertical}px ${bs_data?.blur}px ${bs_data?.spread}px ${bs_data?.color}`
                        }

                        var g_var2 = `var(--tpgb-BS${value})`;
                        tmp_content = tmp_content.replaceAll(g_var2, shadow_val);

                        new_data = bs_data;
                    } else if (key === "globalTypo") {
                        let index = global_data.typography.findIndex((c_data) => (Number(c_data.temp_id) + 1) == value);
                        let temp_data = global_data.typography[index];

                        let typo_data = temp_data?.data?.value;

                        if (temp_data?.status == 'update') {
                            if (typo_data?.fontFamily?.family) {
                                var g_font_family = `var(--tpgb-${value}-font-family)`;
                                var r_font_family = `var(--tpgb-${temp_data.site_id}-font-family)`;
                                tmp_content = tmp_content.replaceAll(g_font_family, r_font_family);
                            }

                            if (typo_data?.fontFamily?.fontWeight) {
                                var g_font_weight = `var(--tpgb-${value}-font-weight)`;
                                var r_font_weight = `var(--tpgb-${temp_data.site_id}-font-weight)`;
                                tmp_content = tmp_content.replaceAll(g_font_weight, r_font_weight);
                            }

                            if (typo_data?.fontStyle) {
                                var g_font_style = `var(--tpgb-${value}-font-style)`;
                                var r_font_style = `var(--tpgb-${temp_data.site_id}-font-style)`;
                                tmp_content = tmp_content.replaceAll(g_font_style, r_font_style);
                            }

                            if (typo_data?.size?.md && typo_data?.size?.unit) {
                                var g_font_size = `var(--tpgb-${value}-font-size)`;
                                var r_font_size = `var(--tpgb-${temp_data.site_id}-font-size)`;
                                tmp_content = tmp_content.replaceAll(g_font_size, r_font_size);
                            }

                            if (typo_data?.height?.md && typo_data?.height?.unit) {
                                var g_font_height = `var(--tpgb-${value}-line-height)`;
                                var r_font_height = `var(--tpgb-${temp_data.site_id}-line-height)`;
                                tmp_content = tmp_content.replaceAll(g_font_height, r_font_height);
                            }

                            if (typo_data?.spacing?.md && typo_data?.spacing?.unit) {
                                var g_font_spacing = `var(--tpgb-${value}-letter-spacing)`;
                                var r_font_spacing = `var(--tpgb-${temp_data.site_id}-letter-spacing)`;
                                tmp_content = tmp_content.replaceAll(g_font_spacing, r_font_spacing);
                            }

                            if (typo_data?.textTransform) {
                                var g_font_transfrom = `var(--tpgb-${value}-text-transform)`;
                                var r_font_transfrom = `var(--tpgb-${temp_data.site_id}-text-transform)`;
                                tmp_content = tmp_content.replaceAll(g_font_transfrom, r_font_transfrom);
                            }

                            if (typo_data?.textDecoration) {
                                var g_font_decoration = `var(--tpgb-${value}-text-decoration)`;
                                var r_font_decoration = `var(--tpgb-${temp_data.site_id}-text-decoration)`;
                                tmp_content = tmp_content.replaceAll(g_font_decoration, r_font_decoration);
                            }

                            Object.assign(typo_data, { 'globalTypo': temp_data.site_id })
                        } else if (temp_data?.status == 'remove') {

                            if (typo_data?.fontFamily?.family) {
                                var g_font_family = `var(--tpgb-${value}-font-family)`;
                                tmp_content = tmp_content.replaceAll(g_font_family, typo_data.fontFamily.family);
                            }

                            if (typo_data?.fontFamily?.fontWeight) {
                                var g_font_weight = `var(--tpgb-${value}-font-weight)`;
                                tmp_content = tmp_content.replaceAll(g_font_weight, typo_data.fontFamily.fontWeight);
                            }

                            if (typo_data?.fontStyle) {
                                var g_font_style = `var(--tpgb-${value}-font-style)`;
                                tmp_content = tmp_content.replaceAll(g_font_style, typo_data.fontStyle);
                            }

                            if (typo_data?.size?.md && typo_data?.size?.unit) {
                                var g_font_size = `var(--tpgb-${value}-font-size)`;
                                tmp_content = tmp_content.replaceAll(g_font_size, typo_data.size.md + typo_data.size.unit);
                            }

                            if (typo_data?.height?.md && typo_data?.height?.unit) {
                                var g_font_height = `var(--tpgb-${value}-line-height)`;
                                tmp_content = tmp_content.replaceAll(g_font_height, typo_data.height.md + typo_data.height.unit);
                            }

                            if (typo_data?.spacing?.md && typo_data?.spacing?.unit) {
                                var g_font_spacing = `var(--tpgb-${value}-letter-spacing)`;
                                tmp_content = tmp_content.replaceAll(g_font_spacing, typo_data.spacing.md + typo_data.spacing.unit);
                            }

                            if (typo_data?.textTransform) {
                                var g_font_transfrom = `var(--tpgb-${value}-text-transform)`;
                                tmp_content = tmp_content.replaceAll(g_font_transfrom, typo_data.textTransform);
                            }

                            if (typo_data?.textDecoration) {
                                var g_font_decoration = `var(--tpgb-${value}-text-decoration)`;
                                tmp_content = tmp_content.replaceAll(g_font_decoration, typo_data.textDecoration);
                            }
                        }

                        new_data = typo_data;
                    }
                }
            });

            for (const key in new_data) {
                new_data[key] = traverse(new_data[key]);
            }

            return new_data;
        } else {
            return obj;
        }
    };

    let update_json = traverse(blockObjects);

    matches.map((match, index) => {
        if (!match[1]) {
            return;
        }

        let content_obj = JSON.parse(match[1]);
        let object_id = content_obj?.block_id ? content_obj.block_id : '';
        let new_obj_id = update_json?.[index]?.block_id ? update_json?.[index]?.block_id : '';

        if (object_id) {
            if (new_obj_id && (object_id == new_obj_id)) {
                let new_obj = update_json?.[index] ? update_json?.[index] : '';
                let matchs = match[1];

                tmp_content = tmp_content.replace(matchs, JSON.stringify(new_obj));

            } else {
                let idx = update_json.findIndex((data) => data.block_id == object_id);

                if (idx > -1) {
                    let new_obj = update_json?.[idx] ? update_json?.[idx] : '';
                    let matchs = match[1];

                    tmp_content = tmp_content.replace(matchs, JSON.stringify(new_obj));
                }
            }
        }
    })

    return tmp_content;
};